import { setCookie, getCookie } from "Functions/cookie";

const agreeBtn = document.querySelector(".js-age-accept");

if (agreeBtn) {
    agreeBtn.addEventListener("click", (event) => {
        event.preventDefault();

        $("#age").modal("hide");
        setCookie("accept_age_svetnapojov", "1", 30);
    });
}

// HIDDEN for en_US, because https://riesenia.atlassian.net/browse/SVET-2075
if (getCookie("accept_age_svetnapojov") !== "1") {
    $("#age").modal("show");
}
